import {
  Box,
  Card,
  Flex,
  Grid,
  HStack,
  Skeleton,
  SkeletonCircle,
  VStack,
} from "@chakra-ui/react";

const skeletonProps = {
  bg: "#DAE9FF",
  borderRadius: "md",
};

const cardProps = {
  bg: "white",
  border: "none",
  borderWidth: 0,
  boxShadow: "sm",
  borderRadius: "2xl",
};

const ProfileSummarySkeleton = () => (
  <Card.Root {...cardProps}>
    <Card.Body
      p={{
        base: 4,
        md: 6,
      }}
    >
      <Flex
        direction={{
          base: "column",
          sm: "row",
        }}
        align={{
          base: "center",
          sm: "center",
        }}
        gap={5}
      >
        <SkeletonCircle
          bg="#DAE9FF"
          size={{
            base: "16",
            md: "20",
          }}
        />

        <Box
          flex={1}
          w={{
            base: "100%",
            sm: "auto",
          }}
        >
          <Skeleton
            {...skeletonProps}
            h="24px"
            w={{
              base: "70%",
              md: "220px",
            }}
            mb={3}
          />

          <Skeleton
            {...skeletonProps}
            h="14px"
            w={{
              base: "55%",
              md: "160px",
            }}
            mb={2}
          />

          <Skeleton
            {...skeletonProps}
            h="12px"
            w={{
              base: "45%",
              md: "120px",
            }}
          />
        </Box>
      </Flex>
    </Card.Body>
  </Card.Root>
);

const InformationSkeleton = ({
  rows = 6,
}) => (
  <Card.Root {...cardProps}>
    <Card.Body
      p={{
        base: 4,
        md: 6,
      }}
    >
      <Skeleton
        {...skeletonProps}
        h="20px"
        w={{
          base: "140px",
          md: "180px",
        }}
        mb={6}
      />

      <VStack
        align="stretch"
        gap={5}
      >
        {Array.from({
          length: rows,
        }).map((_, i) => (
          <Box key={i}>
            <Skeleton
              {...skeletonProps}
              h="10px"
              w="120px"
              mb={2}
            />

            <Skeleton
              {...skeletonProps}
              h="16px"
              w={`${60 + Math.random() * 30}%`}
            />
          </Box>
        ))}
      </VStack>
    </Card.Body>
  </Card.Root>
);

const ReferralSkeleton = () => (
  <Card.Root {...cardProps}>
    <Card.Body
      p={{
        base: 4,
        md: 6,
      }}
    >
      <Flex
        direction="column"
        align="center"
      >
        <SkeletonCircle
          bg="#DAE9FF"
          size={{
            base: "14",
            md: "16",
          }}
          mb={5}
        />

        <Skeleton
          {...skeletonProps}
          h="20px"
          w={{
            base: "150px",
            md: "180px",
          }}
          mb={3}
        />

        <Skeleton
          {...skeletonProps}
          h="14px"
          w={{
            base: "120px",
            md: "140px",
          }}
          mb={6}
        />

        <Flex
          w="100%"
          direction={{
            base: "column",
            sm: "row",
          }}
          gap={3}
          mb={6}
        >
          <Skeleton
            {...skeletonProps}
            h="50px"
            flex={1}
          />

          <Skeleton
            {...skeletonProps}
            h="50px"
            flex={1}
          />
        </Flex>

        <Skeleton
          {...skeletonProps}
          h="40px"
          w="100%"
        />
      </Flex>
    </Card.Body>
  </Card.Root>
);

export default function ProfileSkeleton() {
  return (
    <>
      {/* Header */}

      <Box
        mb={{
          base: 6,
          md: 8,
        }}
      >
        <Skeleton
          {...skeletonProps}
          h="36px"
          w={{
            base: "200px",
            md: "300px",
          }}
          mb={3}
        />

        <Skeleton
          {...skeletonProps}
          h="16px"
          w={{
            base: "100%",
            md: "430px",
          }}
        />
      </Box>

      <Grid
        templateColumns={{
          base: "1fr",
          xl: "2fr 360px",
        }}
        gap={{
          base: 4,
          md: 6,
        }}
      >
        <Flex
          direction="column"
          gap={{
            base: 4,
            md: 6,
          }}
        >
          <ProfileSummarySkeleton />

          <InformationSkeleton
            rows={7}
          />

          <InformationSkeleton
            rows={4}
          />
        </Flex>

        <Flex
          direction="column"
          gap={{
            base: 4,
            md: 6,
          }}
        >
          <ReferralSkeleton />

          <InformationSkeleton
            rows={5}
          />
        </Flex>
      </Grid>
    </>
  );
}